import { useSyncExternalStore } from 'react'

// Whether the app bootstrap is waiting to reach Cerebro again. Kept outside
// Redux: it is transient UI state that only App reads.
let reconnecting = false
const listeners = new Set<() => void>()

function subscribe(listener: () => void): () => void {
    listeners.add(listener)
    return () => {
        listeners.delete(listener)
    }
}

export function setReconnecting(value: boolean): void {
    if (reconnecting === value) {
        return
    }
    reconnecting = value
    listeners.forEach((listener) => listener())
}

export function useIsReconnecting(): boolean {
    return useSyncExternalStore(subscribe, () => reconnecting)
}
